import Axios from 'axios';
import { UserState } from '../model/user/types';
import { sessionMiddleware } from './login';

export default class UserAPI
{
    // ------- USER ------- //

    static getUserData() : Promise<UserState>
    {
        return Axios.get('./api/users/current')
            .then(sessionMiddleware)
            .then((response: any) => {
                return response.data as UserState;
            }).catch((error: any) => {
                console.log(error);
                return {} as UserState;
            });
    }

    static getUserList() : Promise<UserState[]>
    {
        return Axios.get('./api/users/list')
        .then(sessionMiddleware)
        .then((response: any) => {
            return response.data as UserState[];
        }).catch((error: any) => {
            console.log(error);
            return [] as UserState[];
        });
    }

    static addUser(username: string, password: string, type: string) : Promise<UserState>
    {
        return Axios.post('./api/users/add', {
            username: username,
            password: password,
            type: type
        })
            .then(sessionMiddleware)
            .then((response: any) => {
                return response.data as UserState;
            }).catch((error: any) => {
                console.log(error);
                throw error;
            });
    }

    static editUser(id: string, accountName: string, username: string, password: string) : Promise<UserState>
    {
        console.log(id, accountName);
        return Axios.put(`./api/users/${id}`, {
            account: accountName,
            username: username,
            password: password
        })
            .then(sessionMiddleware)
            .then((response: any) => {
                return response.data as UserState;
            }).catch((error: any) => {
                console.log(error);
                throw error;
            });
    }

    static removeUser(id: string) : Promise<UserState>
    {
        return Axios.delete(`./api/users/${id}`)
            .then(sessionMiddleware)
            .then((response: any) => {
                return response.data as UserState;
            }).catch((error: any) => {
                console.log(error);
                throw error;
            });
    }

    // ---------------------- //
}